import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';

import useAccountDetails from '#client/hooks/useAccountDetails';

import MenuItemRow from './MenuItemRow';

export default function AccountDetails() {
  const { accountNumberText, copyAddress, nameText, renderAddress, routingNumberText } =
    useAccountDetails();
  const buttonPressedTracker = useClickstreamCallback('buttonPressed');

  const trackingClickCopyButtonEvent = (buttonText) => () => {
    buttonPressedTracker({
      elementName: buttonText,
      elementText: buttonText,
      appPageName: 'active_banking_dashboard'
    });
  };

  return [
    <MenuItemRow
      /**
       * Tracking Details: Tracking added to Account Details button
       * Question: How many users click the account number copy buttons?
       */
      callback={trackingClickCopyButtonEvent('copy_account_number')}
      copyText={accountNumberText}
      key="account-number"
      menuKey="account-number"
      texts={[accountNumberText]}
      title="ACCOUNT NUMBER"
    />,
    <MenuItemRow
      /**
       * Tracking Details: Tracking added to Account Details button
       * Question: How many users click the routing number copy buttons?
       */
      callback={trackingClickCopyButtonEvent('copy_routing_number')}
      copyText={routingNumberText}
      key="routing-number"
      menuKey="routing-number"
      texts={[routingNumberText]}
      title="ROUTING NUMBER"
    />,
    <Box
      key="caption"
      pt="4px"
    >
      <Text size="xs">Receive Wire Transfers</Text>
    </Box>,
    <MenuItemRow
      copyText={nameText}
      key="account-name"
      menuKey="account-name"
      texts={[nameText]}
      title="ACCOUNT NAME"
    />,
    <MenuItemRow
      copyText="Thread Bank"
      key="bank-name"
      menuKey="bank-name"
      texts={['Thread Bank']}
      title="BANK NAME"
    />,
    <MenuItemRow
      copyText={copyAddress}
      key="bank-address"
      menuKey="bank-address"
      texts={renderAddress}
      title="ADDRESS"
    />
  ];
}
